import {FlexGridColumnGroup} from '@grapecity/wijmo.react.grid';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {Field, getFormSyncWarnings, getFormValues, reduxForm} from 'redux-form';
import {GMN, GMN_PATH} from '../../../../common/commonConst.js';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
// import {sysErr} from '../../../../common/commonGmn.js';
import {commonOperations} from '../../../../reducks/common/index.js';
import CustomFlexGrid from '../../../molecules/CustomFlexGrid.js';
import PaperPart from '../../../atoms/PaperPart.js';
import {renderTextField, renderSelect} from '../../../atoms/CustomPart.js';
import MainContainer from '../../../organisms/MainContainer.js';
import withRouter from '../../../organisms/withRouter.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
import CustomAccordion from '../../../molecules/Accordion.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
import SearchIcon from '@mui/icons-material/Search';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import withFormatMessage from '../../../organisms/withFormatMessage.js';
import {withMediaQuery} from '../../../atoms/withMediaQuery.js';
import {withStyles} from '@mui/styles';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';

const styles = (theme) => ({
  fields: {
    'margin': '0px 10px 15px 10px',
  },
});

// 毎年調査お客さま全使撤リスト(調査機関用)
const henkomaeViews = [
  {binding: 'haisiFlag', header: '廃止', required: false, dataType: 'Boolean', width: 80, sm: 3, readOnly: true},
  {header: '全使撤リスト', dataType: 'header', elems: [
    {binding: 'blockBango', header: 'ブロック番号', required: false, dataType: 'String', width: 130, readOnly: true},
    {binding: 'supplyPointNo', header: '供給地点特定番号', required: false, dataType: 'String', width: 220, readOnly: true},
    {binding: 'customerName', header: 'お客さま名', required: false, dataType: 'String', width: 200, readOnly: true},
    {binding: 'hijikaCode', header: '調査管理区分', required: false, dataType: 'String', width: 200, sm: 3, readOnly: true},
    {binding: 'chousaGyousyu', header: '調査業種', required: false, dataType: 'String', width: 200, sm: 3, readOnly: true},
    {binding: 'bikou', header: '備考', required: false, dataType: 'String', width: 300, readOnly: false},
  ]},
  {header: '引き継ぎ', dataType: 'header', elems: [
    {binding: 'blockBangoHk', header: 'ブロック番号', required: false, dataType: 'String', width: 130, readOnly: true},
    {binding: 'supplyPointNoHk', header: '供給地点特定番号', required: false, dataType: 'String', width: 220, readOnly: true},
    {binding: 'customerNameHk', header: 'お客さま名', required: false, dataType: 'String', width: 200, readOnly: true},
    {binding: 'hijikaCodeHk', header: '調査管理区分', required: false, dataType: 'String', width: 200, sm: 3, readOnly: true},
    {binding: 'chousaGyousyuHk', header: '調査業種', required: false, dataType: 'String', width: 200, sm: 3, readOnly: true},
  ]},
];

/**
 * 毎年調査お客さま全使撤リスト(調査機関用)
 * 画面ID:
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    // 調査管理区分
    let hijikaCode = [
      {id: '0', name: '0:非自家用'},
      {id: '1', name: '1:高圧非自家(毎年調査)'},
      {id: '2', name: '2:高圧非自家(隔年調査)'},
      {id: '3', name: '3:低圧自家用'},
      {id: '4', name: '4:調査拒否'},
      {id: '5', name: '5:非自家の取消(自主的に自家用化)'},
      {id: '6', name: '6:非自家の取消(増設50kW以上)'},
      {id: '7', name: '7:非自家の取消(全使撤,低圧化)'},
      {id: '8', name: '8:非自家の取消(その他)'},
    ];
    // 調査業種
    let chousaGyousyuCode = [
      {id: '01', name: '01:ＮＴＴ拒否'},
      {id: '02', name: '02:寝たきり'},
      {id: '03', name: '03:プール'},
      {id: '04', name: '04:浴場'},
      {id: '05', name: '05:学校等'},
      {id: '06', name: '06:老人福祉'},
      {id: '07', name: '07:重要文化財'},
      {id: '08', name: '08:学校でかつプール施設'},
    ];
    // 廃止
    let haisiFlag = [
      {id: '0', name: ''},
      {id: '1', name: '廃止'},
    ];
    // パラメータ取得
    const _list = [
      {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
      {gmnName: GMN.ZENSITETU_ITAKU_LIST.name, href: ''},
    ];

    this.state = {
      warningMessages: [],
      transitionList: _list,
      henkoJohomaeList: [],
      seiHeaderDate: {},
      hijikaList: hijikaCode,
      chousaGyousyuList: chousaGyousyuCode,
      haisiList: haisiFlag,
      buttonDisabled: true,
      listZigyojoMst: [],
      modalOpen: false,
      gamenData: {},
      gridRefErr: false,
      rowId: 0,
      showApprovalModal: false,
    };
    // 一覧Ref作成
    this.gridRef = React.createRef();
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
  }

  /**
   * 配列検索
   * @param {array} list
   * @param {string} label
   * @return {number} インデックス
   */
  findIndex = (list, label) => {
    return list.findIndex((element) => {
      return element.label === label;
    });
  };

  /**
   * 一覧パーツ取得
   * @param {*} view 設定
   * @return {*} 一覧パーツ
   */
  getViewElem = (view) => {
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      dataType={view.dataType}
      format={view.format}
      width={view.width}
      isReadOnly={view.readOnly}/>;
  };

  /**
   * ロード時、廃止の行はグレーにする
   * @param {*} s
   * @param {*} e
   */
  loadedRowsFunction = (s, e) => {
    for (const row of s.rows) {
      if (row._data.haisiFlag === true) {
        // 対象外の場合、行をグレーにする
        row.cssClass = 'bf-gray-background';
      } else {
        row.cssClass = '';
      }
    }
  };

  /**
   * セル編集終了時の処理
   * @param {*} grid グリッド
   * @param {*} event イベント
   */
  onCellEditEndedFunction = (grid, event) => {
    const binding = event.panel.columns[event.col]?.binding;
    let item = grid.collectionView.items[event.row];
    if (!item) {
      return;
    }
    // 廃止フラグの変更
    if (item && binding === 'haisiFlag') {
      if (item.haisiFlag === true) {
        // 廃止の場合、行をグレーにする
        event.panel.rows[event.row].cssClass = 'bf-gray-background';
      } else {
        event.panel.rows[event.row].cssClass = '';
      }
    }
    grid.refresh();
  };

  /**
   * 全使撤一覧描画
   * @return {*}
   */
  renderTable() {
    const props = {
      rowHeaderType: 'None',
      id: 'SCA1012HenkomaeTable',
      filterOn: true,
      headersVisibility: 'Column',
      allowDragging: 'None',
      isDisplayCount: true,
      style: {height: 'auto', maxHeight: '380px', maxWidth: '100%', width: 'auto'},
      isReadOnly: false,
      screenId: 'SCA1012Henkomae',
      checkedFunction: this.checkStateUpdate,
      doShowMessage: this.props.doShowMessage,
      validateEdits: true,
      cellEditEndedFunction: this.onCellEditEndedFunction,
      loadedRowsFunction: this.loadedRowsFunction,
    };
    // 一覧定義取得
    let viewElems = [];
    if (henkomaeViews) {
      for (const view of henkomaeViews) {
        let viewElem;
        if (view.dataType === 'header') {
          let viewGroups = [];
          for (const elem of view.elems) {
            viewGroups.push(this.getViewElem(elem));
          }
          viewElem = <FlexGridColumnGroup header={view.header}>
            {viewGroups}
          </FlexGridColumnGroup>;
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }
    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }

  /**
   * 終了処理
   */
  async componentWillUnmount() {
    this.props.reset();
    this.props.doSetInitValues(null);
  }

  /**
   * 検索処理
   */
  _searchOrder = async () => {
    // 変更前リストデータを画面に設定
    let henkoJohomaeList = [
      {haisiFlag: false, blockBango: '00001', supplyPointNo: '01 2345 6789 0123 4567 8901', customerName: '△△△△△△△△△△会社', hijikaCode: '非自家用', chousaGyousyu: 'ＮＴＴ拒否', bikou: '調査理由、コメントする', blockBangoHk: '00002', supplyPointNoHk: '02 2345 6789 0123 4567 8901,02 2345 6789 0123 4567 8902', customerNameHk: '△△△△△△△△△△会社,○○○○会社', hijikaCodeHk: '非自家用,非自家用', chousaGyousyuHk: 'ＮＴＴ拒否,寝たきり'},
      {haisiFlag: false, blockBango: '00002', supplyPointNo: '01 2345 6789 0123 4567 8902', customerName: '◇◇◇◇◇◇◇◇◇◇会社', hijikaCode: '非自家用', chousaGyousyu: '寝たきり', bikou: '調査理由、コメントする', blockBangoHk: '00003', supplyPointNoHk: '03 2345 6789 0123 4567 8901', customerNameHk: '△△△△△△△△△△会社', hijikaCodeHk: '非自家用', chousaGyousyuHk: 'ＮＴＴ拒否'},
      {haisiFlag: true, blockBango: '00004', supplyPointNo: '01 2345 6789 0123 4567 8903', customerName: '○○○○○○○○○○○○○○○会社', hijikaCode: '低圧自家用', chousaGyousyu: 'プール', bikou: '調査理由、コメントする'},
      {haisiFlag: false, blockBango: '00005', supplyPointNo: '01 2345 6789 0123 4567 8904', customerName: '○○○○○○○○○○○○○○○会社', hijikaCode: '調査拒否', chousaGyousyu: '浴場', bikou: '調査理由、コメントする'},
      {haisiFlag: true, blockBango: '00006', supplyPointNo: '01 2345 6789 0123 4567 8905', customerName: '○○○○○○○○○○○○○○○会社', hijikaCode: '非自家の取消(自主的に自家用化)', chousaGyousyu: '学校等', bikou: '調査理由、コメントする'},
      {haisiFlag: true, blockBango: '00007', supplyPointNo: '01 2345 6789 0123 4567 8906', customerName: '○○○○○○○○○○○○○○○会社', hijikaCode: '非自家の取消(増設50kW以上)', chousaGyousyu: '老人福祉', bikou: '調査理由、コメントする'},
      {haisiFlag: true, blockBango: '00008', supplyPointNo: '01 2345 6789 0123 4567 8907', customerName: '○○○○○○○○○○○○○○○会社', hijikaCode: '非自家の取消(全使撤,低圧化)', chousaGyousyu: '重要文化財', bikou: '調査理由、コメントする'},
      {haisiFlag: false, blockBango: '00009', supplyPointNo: '01 2345 6789 0123 4567 8908', customerName: '○○○○○○○○○○○○○○○会社', hijikaCode: '非自家の取消(その他)', chousaGyousyu: '学校でかつプール施設', bikou: '調査理由、コメントする'},
      {haisiFlag: false, blockBango: '00010', supplyPointNo: '01 2345 6789 0123 4567 8909', customerName: '○○○○○○○○○○○○○○○会社', hijikaCode: '非自家の取消(その他)', chousaGyousyu: 'ＮＴＴ拒否', bikou: '調査理由、コメントする'},
      {haisiFlag: false, blockBango: '00011', supplyPointNo: '01 2345 6789 0123 4567 8910', customerName: '○○○○○○○○○○○○○○○会社', hijikaCode: '高圧非自家(毎年調査)', chousaGyousyu: 'プール', bikou: '調査理由、コメントする'},
      {haisiFlag: false, blockBango: '00012', supplyPointNo: '01 2345 6789 0123 4567 8911', customerName: '○○○○○○○○○○○○○○○会社', hijikaCode: '高圧非自家(隔年調査)', chousaGyousyu: '重要文化財', bikou: '調査理由、コメントする'},
    ];

    this.gridRef.current.setItemsSource(henkoJohomaeList);
    return true;
  };

  /**
   * クリア処理
   */
  _reset = async () => {
    this.setState({buttonDisabled2: true, warningMessages: []});
    const values = this.props.values;
    console.log(values);
    await this.props.reset();
    const data =[];
    this.gridRef.current.setItemsSource(data);
    return true;
  };

  /**
   * 検索ボタン押下時処理
   * @param {bool} show
   */
  doSearch = async () => {
    this.setState({buttonDisabled2: false});
    this._searchOrder();
  };

  /**
   * 検索条件タブの要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  renderCondition() {
    const {classes} = this.props;
    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="zigyoujo" item xs={12} sm={2}>
            <Field
              id="zigyoujo"
              name=""
              // variant="standard"
              component={renderSelect}
              className={classes.fields}
              label="NW事業所"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={5160}>{'広島北NWC'}</MenuItem>
              <MenuItem value={6120}>{'山口NWC'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="tyousakikan" item xs={12} sm={2}>
            <Field
              id="tyousakikan"
              name="tyousakikan"
              // variant="standard"
              component={renderSelect}
              className={classes.fields}
              label="調査会社"
              fullWidth
              required={true}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={3000}>{'保安協会'}</MenuItem>
              <MenuItem value={5000}>{'工業組合'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="tskkJgyosyo" item xs={12} sm={2}>
            <Field
              id="tskkJgyosyo"
              name="tskkJgyosyo"
              // variant="standard"
              component={renderSelect}
              className={classes.fields}
              label="調査機関事業所"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={4510}>{'福山支'}</MenuItem>
              <MenuItem value={4580}>{'府中支'}</MenuItem>

            </Field>
          </Grid>
          <Grid key="customerName" item xs={12} sm={2}>
            <Field
              id="customerName"
              name="customerName"
              // variant="standard"
              component={renderTextField}
              className={classes.fields}
              label="お客さま名"
              fullWidth
              type="text"
              required={false}
              validate={[
                // validateRule.number,
                // validateRule.maxLength(22),
              ]}
            />
          </Grid>
          <Grid key="supplyPointNo" item xs={12} sm={2}>
            <Field
              id="supplyPointNo"
              name="supplyPointNo"
              // variant="standard"
              component={renderTextField}
              className={classes.fields}
              label="供給地点特定番号"
              fullWidth
              type="text"
              required={false}
              validate={[
                // validateRule.number,
                // validateRule.maxLength(22),
              ]}
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="blockNoFrom" item xs={12} sm={2}>
            <Field
              id="blockNoFrom"
              name="blockNoFrom"
              label="ブロック番号"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              type="text"
              required={false}
            />
          </Grid>
          <Typography sx={{margin: '18px 0px 20px 25px'}}>
            ～
          </Typography>
          <Grid key="blockNoTo" item xs={12} sm={2}>
            <Field
              id="blockNoTo"
              name="blockNoTo"
              label=""
              component={renderTextField}
              className={classes.fields}
              fullWidth
              type="text"
              required={false}
            />
          </Grid>
          <Grid key="fromdate" item xs={12} sm={2}>
            <Field
              id="fromdate"
              name="fromdate"
              // variant="standard"
              component={renderTextField}
              className={classes.fields}
              label="作成日"
              fullWidth
              type="date"
              required={false}
              InputLabelProps={{
                shrink: true,
              }}
              validate={[
                // validateRule.number,
                // validateRule.maxLength(22),
              ]}
            />
          </Grid>
          <Typography sx={{margin: '18px 0px 20px 25px'}}>
            ～
          </Typography>
          <Grid key="todate" item xs={12} sm={2}>
            <Field
              id="todate"
              name="todate"
              // variant="standard"
              component={renderTextField}
              className={classes.fields}
              // label="作成日"
              fullWidth
              type="date"
              required={false}
              InputLabelProps={{
                shrink: true,
              }}
              validate={[
                // validateRule.number,
                // validateRule.maxLength(22),
              ]}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    // const {
    //   handleSubmit,
    // } = this.props;

    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
      </Grid>
    );
  };

  /**
   * 画面描画
   * @return {*}
   */
  render() {
    const {
      // classes,
      handleSubmit,
      userInfo,
    } = this.props;

    // フッタボタンを生成
    const footerBtn = this.renderFooterBtn();

    return (
      <form noValidate autoComplete="off" className="form_root">
        <MainContainer
          props={this.props}
          ActorName={userInfo.ActorName}
          footerBtn={footerBtn}
        >
          <Grid key="keySCA1012Msg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages}/>
          </Grid>
          <CustomBreadcrumbs key="keyBreadcrumbs" items={this.state.transitionList}/>
          <Grid key="keySCA1012OrderGrid" item xs={12}>
            <PaperPart>
              <Grid
                container
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={1}
              >
                <Grid key="search" item xs={12}>
                  <CustomAccordion title='検索条件' items={[this.renderCondition()]} defaultExpanded={true}/>
                </Grid>
              </Grid>
              <Grid
                container
                justifyContent="right"
                alignItems="right"
              >
                <Grid key="clear" item>
                  <NegativeButton
                    id="clear"
                    variant="contained"
                    startIcon={<RotateLeftIcon />}
                    className='button_list'
                    size="middle"
                    onClick={handleSubmit(this._reset)}
                  >
                    <span>クリア</span>
                  </NegativeButton>
                </Grid>
                <Grid key="search" item>
                  <PositiveButton
                    id="search"
                    variant="contained"
                    startIcon={<SearchIcon />}
                    className="button_list"
                    size="middle"
                    onClick={handleSubmit(this.doSearch)}
                  >
                    <span>検索</span>
                  </PositiveButton>
                </Grid>
              </Grid>
            </PaperPart>
            <div style={{marginBottom: '20px'}} />
            <Divider variant="middle" />
            <div style={{marginBottom: '4px'}} />
            <Grid container
              justifyContent="flex-start"
              alignItems="flex-start"
            >
              <Grid key="keySCA1012HenkomaeTable" item xs={12}>
                {this.renderTable()}
              </Grid>
            </Grid>
          </Grid>

        </MainContainer>
      </form>
    );
  }
}

const FORM_NAME = 'SCA1012FORM';
Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
    syncWarnings: getFormSyncWarnings(FORM_NAME)(state),
  };
})(Container));

Container.propTypes = {
  classes: PropTypes.object,
  userInfo: PropTypes.object,
  values: PropTypes.object,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doSetInitValues: PropTypes.func,
  navigate: PropTypes.func,
  title: PropTypes.string,
  genericMap: PropTypes.object,
  getMessage: PropTypes.func,
  reset: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    userInfo: state.auth.userInfo,
    initialValues: state.common.setInitValues,
    genericMap: state.common.generalPurposeMap,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doSetInitValues: commonOperations.doSetInitValues,
};

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(withFormatMessage(withMediaQuery()(Container)))),
);

